<template>
  <v-container
    id="renewalTab"
    class="pa-0"
  >
    <base-resource-grid
      color="green"
      icon="mdi-refresh"
      plural-name="Renewal"
      singular-name="Renewal"
      allow-expand
      :headers="gridHeaders"
      :resource="renewalResource"
      :fetch-method="getRenewal"
      :custom-columns="customColumns"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template
        v-slot:item.rateChange="{ item }"
      >
        <span
          :class="{
            'renewal-changed-text': item.rateChange,
            'renewal-not-changed-text': !item.rateChange,
          }"
        >
          {{ item.rateChange ? 'Yes' : 'No' }}
        </span>
      </template>
      <template
        v-slot:item.newPlanOffering="{ item }"
      >
        <span
          :class="{
            'renewal-changed-text': item.newPlanOffering,
            'renewal-not-changed-text': !item.newPlanOffering,
          }"
        >
          {{ item.newPlanOffering ? 'Yes' : 'No' }}
        </span>
      </template>
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <renewal-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :open-enrollment="openEnrollment"
          :form-errors="bindings.formErrors"
          :disabled="disabled"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeRenewalHistory/"
      id-field="oeRenewalId"
      title-field="Renewal"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'RenewalTab',

    components: {
      RenewalEdit: () => import('./RenewalEdit'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      customColumns: [
        'rateChange',
        'newPlanOffering',
      ],

      gridHeaders: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Change',
          value: 'change',
        },
        {
          text: 'Rate Change',
          value: 'rateChange',
        },
        {
          text: 'New Plan Offering',
          value: 'newPlanOffering',
        },
      ],

      historyColumns: [
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Change',
          value: 'change',
          dataType: 'boolean',
        },
        {
          text: 'Rate Change',
          value: 'rateChange',
          dataType: 'boolean',
        },
        {
          text: 'Carrier Change',
          value: 'carrierChange',
          dataType: 'boolean',
        },
        {
          text: 'New Plan Offering',
          value: 'newPlanOffering',
          dataType: 'boolean',
        },
        /*
        {
          text: 'New Hire GI Rules',
          value: 'newHireGIRules',
        },
        {
          text: 'Late Entrant GI Rules',
          value: 'lateEntrantGIRules',
        },
        {
          text: 'Increases To Existing GI Rules',
          value: 'increasesToExistingGIRules',
        },
        */
        {
          text: 'New Plan',
          value: 'manuallyAdded',
          dataType: 'boolean',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      renewalResource: new TroodyApi('oeRenewal/'),

      historyItem: null,
    }),

    methods: {
      getRenewal () {
        return this.renewalResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>

<style lang="sass">
.renewal-changed-text
  color: red
  font-weight: 800

.renewal-not-changed-text
  color: green
</style>
